import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

const CompanyInfoSchema = new mongoose.Schema({
  domain: {
    type: String,
    unique: true,
  },
  name: { type: String },
  companyLinkedin: { type: String },
  foundedYear: { type: String },
  annualRevenue: { type: String },
  totalFunding: { type: String },
  location: { type: String },
  industries: { type: String },
  description: { type: String },
  productServices: { type: String },
  employees: { type: String },
  website: { type: String },
  created: { type: Date, default: Date.now() },
  lastUpdated: { type: Date },
});

export type T_CompanyInfo = InferSchemaType<typeof CompanyInfoSchema>;

export type T_CompanyInfoDocument = T_CompanyInfo &
  Document & {
    _id: string;
  };

export { CompanyInfoSchema };
